/* pop-diwali.js — People of Prints · Diwali Gifting landing page */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Sticky nav ---------- */
  function initNav() {
    var nav = $('#dw-nav');
    if (!nav) return;
    var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var burger = $('[data-dw-burger]', nav);
    var menu = $('#dw-mobile-menu');
    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open'); document.body.classList.remove('dw-menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
    if (burger && menu) {
      burger.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        document.body.classList.toggle('dw-menu-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });
    }

    /* Smooth anchor scrolling with header offset */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      closeMenu();
      var offset = nav.getBoundingClientRect().height + 12;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Hero parallax ---------- */
  function initParallax() {
    var img = $('[data-dw-parallax]');
    if (!img || reduce) return;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (y < window.innerHeight * 1.2) img.style.transform = 'translate3d(0,' + (y * 0.12) + 'px,0) scale(1.06)';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Generic tabs (budget bands, moods) ---------- */
  function initTabs() {
    $$('[data-dw-tabs]').forEach(function (root) {
      var tabs = $$('[data-dw-tab]', root);
      var panels = $$('[data-dw-panel]', root);
      function activate(key, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-dw-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-dw-panel') === key;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
          if (on && focus) {
            /* trigger reveal of newly shown cards */
            $$('[data-reveal]', p).forEach(function (el) { el.classList.add('is-in'); });
          }
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          activate(t.getAttribute('data-dw-tab'), true);
          if (t.hasAttribute('data-dw-scroll-into')) {
            var pr = t.closest('.dw-tabs__strip');
            if (pr && pr.scrollWidth > pr.clientWidth) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
      var initial = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0];
      if (initial) activate(initial.getAttribute('data-dw-tab'), false);
    });
  }

  /* ---------- "View all" expanders ---------- */
  function initExpanders() {
    $$('[data-dw-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-dw-panel]') || btn.closest('section') || btn.parentElement;
        $$('.dw-hidden', panel).forEach(function (el) { el.classList.remove('dw-hidden'); el.classList.add('is-in'); });
        btn.parentElement.removeChild(btn);
      });
    });
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers() {
    $$('[data-dw-scroller]').forEach(function (root) {
      var track = $('[data-dw-track]', root);
      var prev = $('[data-dw-prev]', root);
      var next = $('[data-dw-next]', root);
      if (!track) return;
      function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 24 : 320; }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Gift quick-view modal ---------- */
  function initModal() {
    var modal = $('#dw-modal');
    if (!modal) return;
    var waNumber = modal.getAttribute('data-wa') || '';
    var img = $('[data-m-img]', modal), name = $('[data-m-name]', modal), code = $('[data-m-code]', modal),
        price = $('[data-m-price]', modal), blurb = $('[data-m-blurb]', modal), items = $('[data-m-items]', modal),
        dims = $('[data-m-dims]', modal), wa = $('[data-m-wa]', modal), enquire = $('[data-m-enquire]', modal),
        buy = $('[data-m-buy]', modal), variant = $('[data-m-variant]', modal), tag = $('[data-m-tag]', modal),
        qty = $('[data-m-qty]', modal), msg = $('[data-m-msg]', modal), purl = $('[data-m-url]', modal),
        itemsH = $('[data-m-h]', modal), optWrap = $('[data-m-optwrap]', modal), opt = $('[data-m-opt]', modal),
        optLabel = $('[data-m-optlabel]', modal),
        gal = $('[data-m-gal]', modal), stage = $('[data-m-stage]', modal), thumbs = $('[data-m-thumbs]', modal),
        rich = $('[data-m-rich]', modal), slides = [], slideIdx = 0;

    /* Rich pop-up (live products): gallery of every photo/video + extra details */
    function pauseVideos() { $$('video', modal).forEach(function (v) { v.pause(); }); }
    function showSlide(i) {
      if (!slides.length) return;
      slideIdx = (i + slides.length) % slides.length;
      pauseVideos();
      slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === slideIdx); });
      $$('button', thumbs).forEach(function (b, k) { b.classList.toggle('is-active', k === slideIdx); b.setAttribute('aria-current', k === slideIdx ? 'true' : 'false'); });
      var tb = thumbs.children[slideIdx]; if (tb && tb.scrollIntoView) tb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function fillRich(card) {
      var tpl = card.querySelector('template[data-dw-rich]');
      slides = []; stage.innerHTML = ''; thumbs.innerHTML = ''; rich.innerHTML = '';
      if (!tpl) { gal.hidden = true; img.hidden = false; rich.hidden = true; return; }
      var frag = tpl.content.cloneNode(true);
      $$('.dw-gal__slide', frag).forEach(function (sl, k) {
        stage.appendChild(sl); slides.push(sl);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dw-gal__thumb' + (sl.getAttribute('data-type') !== 'image' ? ' is-video' : '');
        b.setAttribute('aria-label', 'Show ' + (sl.getAttribute('data-type') === 'image' ? 'photo ' : 'video ') + (k + 1));
        b.innerHTML = '<img src="' + sl.getAttribute('data-thumb') + '" alt="" loading="lazy">';
        b.addEventListener('click', function () { showSlide(k); });
        thumbs.appendChild(b);
      });
      var body = frag.querySelector('[data-rich-body]');
      if (body) { while (body.firstChild) rich.appendChild(body.firstChild); }
      rich.hidden = !rich.children.length;
      var many = slides.length > 1;
      gal.hidden = !slides.length; img.hidden = !!slides.length;
      $('[data-m-prev]', gal).hidden = !many; $('[data-m-next]', gal).hidden = !many; thumbs.hidden = !many;
      showSlide(0);
    }
    if (gal) {
      $('[data-m-prev]', gal).addEventListener('click', function () { showSlide(slideIdx - 1); });
      $('[data-m-next]', gal).addEventListener('click', function () { showSlide(slideIdx + 1); });
    }
    var lastFocus = null;

    function fill(card) {
      var d = card.dataset;
      img.src = d.img; img.alt = d.name + ' Diwali hamper';
      name.textContent = d.name; code.textContent = d.code;
      price.innerHTML = '₹' + d.price + ' <span>incl. GST</span>';
      blurb.textContent = d.blurb || '';
      dims.textContent = d.dims ? 'Box size ' + d.dims : '';
      if (itemsH) itemsH.hidden = !(d.items || '').trim();
      if (gal) fillRich(card);
      code.hidden = !d.code;
      items.innerHTML = '';
      (d.items || '').split('|').forEach(function (it) {
        if (!it.trim()) return;
        var li = document.createElement('li'); li.textContent = it.trim(); items.appendChild(li);
      });
      var waMsg = 'Hi People of Prints! I\'m interested in the ' + d.name + ' Diwali hamper (' + (d.code ? d.code + ', ' : '') + '₹' + d.price + ' incl. GST). Could you share details and availability?';
      if (wa) wa.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(waMsg);
      if (buy) {
        buy.hidden = !d.variant;
        variant.value = d.variant || '';
        tag.value = ''; qty.value = 1;
        msg.textContent = ''; msg.classList.remove('is-error');
        if (purl) purl.href = d.url || '#';
        /* Products with options (e.g. box only / full hamper): show a picker */
        var vs = [];
        try { vs = d.variants ? JSON.parse(d.variants) : []; } catch (err) { vs = []; }
        if (optWrap) {
          optWrap.hidden = vs.length < 2;
          opt.innerHTML = '';
          if (vs.length > 1) {
            optLabel.textContent = d.optionName || 'Option';
            vs.forEach(function (v) {
              var o = document.createElement('option');
              o.value = v.id; o.textContent = v.t + ' — ₹' + v.p + (v.a ? '' : ' (sold out)');
              o.disabled = !v.a; o.setAttribute('data-price', v.p);
              if (String(v.id) === String(d.variant)) o.selected = true;
              opt.appendChild(o);
            });
          }
        }
        /* vs is empty for catalogue cards that carry no variant data — those
           keep the normal button rather than being wrongly marked sold out. */
        if (vs.length) {
          var sel = null;
          for (var i = 0; i < vs.length; i++) {
            if (String(vs[i].id) === String(d.variant)) { sel = vs[i]; break; }
          }
          if (!sel) sel = vs[0];
          setBuyState(!!(sel && sel.a));
        } else {
          setBuyState(true);
        }
      }
      if (enquire) enquire.setAttribute('data-gift', d.name + ' (' + d.code + ', ₹' + d.price + ')');
    }
    /* The card already disables its own button for sold-out products, but the
       modal's did not — a customer could click Add to cart and only discover
       it was gone when the server rejected it. Mirror the card's state here. */
    function setBuyState(available) {
      var btn = $('[data-m-add]', modal);
      if (!btn) return;
      btn.disabled = !available;
      btn.textContent = available ? 'Add to cart' : 'Sold out';
    }

    function open(card, toBuy) {
      lastFocus = document.activeElement;
      fill(card);
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.classList.add('dw-modal-open');
      if (toBuy && buy && !buy.hidden) {
        setTimeout(function () { tag.focus(); buy.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }, 120);
      } else {
        var closeBtn = $('[data-dw-close]', modal); if (closeBtn) closeBtn.focus();
      }
    }

    if (opt) opt.addEventListener('change', function () {
      var o = opt.options[opt.selectedIndex];
      if (!o) { setBuyState(false); return; }
      variant.value = o.value;
      price.innerHTML = '₹' + o.getAttribute('data-price') + ' <span>incl. GST</span>';
      setBuyState(!o.disabled);
    });

    if (buy) buy.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('[data-m-add]', buy);
      var fd = new FormData(buy);
      if (!tag.value.trim()) fd.delete('properties[Acrylic tag message]');
      btn.disabled = true; btn.textContent = 'Adding…';
      msg.className = 'dw-shop__msg'; msg.textContent = '';
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
          msg.className = 'dw-shop__msg is-ok';
          msg.innerHTML = 'Added to your cart · <a href="/cart">View cart</a>';
          updateCartBadge();
          flashAdded(btn, 'Add to cart');
        })
        .catch(function (err) {
          msg.classList.add('is-error');
          msg.textContent = err.message || 'Could not add to cart. Please try again.';
        })
        /* Leave the label alone while the ✓ Added state is showing; flashAdded restores it. */
        .then(function () { btn.disabled = false; if (!btn.classList.contains('is-added')) btn.textContent = 'Add to cart'; });
    });
    function close() {
      if (gal) pauseVideos();
      modal.classList.remove('is-open');
      document.body.classList.remove('dw-modal-open');
      setTimeout(function () { modal.hidden = true; }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dw-open]');
      if (opener) { var card = opener.closest('[data-dw-gift]'); if (card) { e.preventDefault(); open(card, opener.hasAttribute('data-dw-buy')); } return; }
      if (e.target.closest('[data-dw-close]') || e.target.classList.contains('dw-modal__backdrop')) { close(); return; }
      var enq = e.target.closest('[data-dw-enquire], [data-m-enquire]');
      if (enq) {
        var card2 = enq.closest('[data-dw-gift]');
        var label = enq.getAttribute('data-gift') || (card2 ? card2.dataset.name + ' (' + card2.dataset.code + ', ₹' + card2.dataset.price + ')' : '');
        setGiftField(label);
        if (!modal.hidden) close();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  function setGiftField(label) {
    var field = $('#DiwaliGiftInterest');
    var note = $('[data-dw-gift-note]');
    if (field) field.value = label;
    if (note) { note.textContent = label ? 'Enquiring about: ' + label : ''; note.hidden = !label; }
  }

  /* ---------- Personalisation tag ---------- */
  function initTag() {
    var wrap = $('[data-dw-tag-scene]');
    if (!wrap) return;
    if (reduce || !('IntersectionObserver' in window)) { wrap.classList.add('is-tagged'); return; }
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { setTimeout(function () { wrap.classList.add('is-tagged'); }, 350); io.disconnect(); }
    }, { threshold: 0.45 });
    io.observe(wrap);
  }

  /* ---------- Mobile sticky bar: hide when the form is visible ---------- */
  function initStickyBar() {
    var bar = $('#dw-sticky-bar'); var form = $('#enquire');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { bar.classList.toggle('is-hidden', en[0].isIntersecting); }, { threshold: 0.2 });
    io.observe(form);
  }

  /* ---------- Reels: lazy playback, sound toggle, embed on click ---------- */
  function initReels() {
    var frames = $$('.dw-reel__frame');
    if (!frames.length) return;

    /* Play uploaded videos only while on screen */
    var vids = $$('.dw-reel__video');
    if (vids.length && 'IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { if (!reduce) v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { vio.observe(v); });
    }

    document.addEventListener('click', function (e) {
      var sound = e.target.closest('[data-dw-sound]');
      if (sound) {
        var frame = sound.closest('.dw-reel__frame');
        var v = frame && frame.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) v.play().catch(function () {});
        var on = sound.querySelector('.dw-reel__sound-on');
        var off = sound.querySelector('.dw-reel__sound-off');
        if (on) on.hidden = v.muted;
        if (off) off.hidden = !v.muted;
        sound.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
        return;
      }

      var embed = e.target.closest('[data-dw-embed]');
      if (embed && !embed.querySelector('iframe')) {
        var type = embed.getAttribute('data-type');
        var id = embed.getAttribute('data-id');
        if (!id) return;
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&loop=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&loop=1&playlist=' + id + '&rel=0&modestbranding=1';
        var f = document.createElement('iframe');
        f.src = src;
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', 'Hamper reel');
        embed.innerHTML = '';
        embed.appendChild(f);
      }
    });
  }

  /* ---------- Shop section: variant price + AJAX add to cart ---------- */
  /* Confirmation on the button itself — the status line alone was too easy to
     miss, which is why adding to cart felt like nothing had happened. */
  function flashAdded(btn, label) {
    if (!btn) return;
    btn.classList.add('is-added');
    btn.textContent = '\u2713 Added';
    setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = label;
    }, 1800);
  }

  function updateCartBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Mirrors login-cart-nav.liquid: count line items, not counting the gift-wrap add-on */
        /* Total quantity, not line count: adding 3 of one hamper should read 3.
           Mirrors cart.item_count minus gift wrap in login-cart-nav.liquid. */
        var count = cart.items.reduce(function (n, it) {
          return it.handle === 'gift-wrap-personalised-card' ? n : n + it.quantity;
        }, 0);
        $$('a[href="/cart"][aria-label="Cart"]').forEach(function (link) {
          var badge = link.querySelector('span');
          if (!count) { if (badge) badge.remove(); return; }
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'absolute -top-1.5 -right-1.5 bg-[#E91E78] text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center leading-none';
            link.appendChild(badge);
          }
          badge.textContent = count;
        });
      })
      .catch(function () {});
  }

  function initShop() {
    $$('[data-dw-variant]').forEach(function (sel) {
      if (sel.dataset.dwBound) return;
      sel.dataset.dwBound = '1';
      sel.addEventListener('change', function () {
        var card = sel.closest('[data-dw-product]');
        var price = card && $('[data-dw-price]', card);
        var opt = sel.options[sel.selectedIndex];
        if (price && opt) price.textContent = opt.getAttribute('data-price');
      });
    });

    $$('[data-dw-add]').forEach(function (form) {
      if (form.dataset.dwBound) return;
      form.dataset.dwBound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return; /* fall back to normal form post */
        e.preventDefault();
        var btn = $('[data-dw-add-btn]', form);
        var msg = $('[data-dw-add-msg]', form);
        var label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…';
        msg.className = 'dw-shop__msg'; msg.textContent = '';
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
            msg.className = 'dw-shop__msg is-ok';
            msg.innerHTML = 'Added to your cart · <a href="/cart">View cart</a>';
            updateCartBadge();
            flashAdded(btn, label);
          })
          .catch(function (err) {
            msg.classList.add('is-error');
            msg.textContent = err.message || 'Could not add to cart. Please try again.';
          })
          .then(function () { btn.disabled = false; if (!btn.classList.contains('is-added')) btn.textContent = label; });
      });
    });
  }

  /* ---------- Match the real site header height ----------
     theme.liquid pads #MainContent by a fixed 9.7rem, but the header is
     taller than that on narrow screens, so the top of the page ends up
     underneath it. Measure the header instead of assuming, and feed the
     value to --dw-nav-h (hero min-height + in-page anchor offsets). */
  function initHeaderOffset() {
    var main = document.getElementById('MainContent');
    /* .w-full.z-50 — not the bare .fixed, which matches #menu-overlay (inset-0, full viewport) */
    var header = document.querySelector('#shopify-section-header .fixed.w-full.z-50');
    if (!main || !header || !document.querySelector('.dw-root')) return;

    var applying = false;
    function apply() {
      if (applying) return;
      applying = true;
      requestAnimationFrame(function () {
        var h = Math.round(header.getBoundingClientRect().height);
        applying = false;
        if (!h) return;                       /* header hidden — chrome-free variant */
        main.style.paddingTop = h + 'px';
        $$('.dw-root').forEach(function (el) { el.style.setProperty('--dw-nav-h', h + 'px'); });
      });
    }

    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);   /* fonts/images can reflow the header */
    if ('ResizeObserver' in window) new ResizeObserver(apply).observe(header);
  }

  function init() {
    initHeaderOffset(); initReveal(); initNav(); initParallax(); initTabs(); initExpanders(); initScrollers(); initModal(); initTag(); initStickyBar(); initReels(); initShop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Re-init inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', function () { initReveal(); initTabs(); initExpanders(); initScrollers(); initReels(); initShop(); });
})();
